module.exports = "<a href=# class=\"list-group-item borderless\"> <span class=filter-text> {%= _.has(optional, 'text') ? text : value %} </span> <input type=checkbox class=pull-right value=\"{%- value %}\"> </a>";


//////////////////
// WEBPACK FOOTER
// ./src/sharedHtml/simpleCheckboxRow.html
// module id = 1449
// module chunks = 1